import React, { FC, useEffect, useState } from 'react'
import ReactTyped from 'react-typed'
import { Grid, Button, Typography, Slide, useTheme, useMediaQuery } from '@material-ui/core'
import RenderIf from '@components/RenderIf'
import useTopToastNotification from '@hooks/useTopToastNotification'
import useStyles from '../styles'
import { SCRIPT_GENERATOR_METHOD, scritpGeneratorScriptContentCopiedTrack } from '@components/SegmentTrackers'
import LoadingScript from '@components/VideoScriptGenerator/LoadingScript'
import SVGCopyClipboard from '@assets/SVGCopyClipboard2'
import { copyToClipboard } from '@utils/index'

interface IEmailPanelProps {
  id: string;
  currentTab: string;
  content: {
    contentScript?: string;
    subjectScript?: string;
  };
}

const EmailPanel: FC<IEmailPanelProps> = ({
  id,
  currentTab,
  content: { subjectScript = '', contentScript = '' }
}) => {
  const [subjectCompleted, setSubjectCompleted] = useState(false)
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { notification } = useTopToastNotification()

  const handleCopyToClipboardEmail = async (contentBody?: string, contentType = 'subject') => {
    scritpGeneratorScriptContentCopiedTrack(SCRIPT_GENERATOR_METHOD.SCRIPT_GENERATOR_SCRIPT_COPYCONTENT, { content: contentType === 'subject' ? 'email subject line' : 'email content' })
    copyToClipboard(contentBody || '', false, notification)
  }

  useEffect(() => {
    if (contentScript && subjectScript) {
      setSubjectCompleted(false)
    }
  }, [contentScript])

  return (
    <Slide direction="left" in={id === currentTab}>
      <Grid container style={{ display: id === currentTab ? 'block' : 'none', height: '100%' }}>
        <RenderIf condition={subjectScript === ''}>
          <LoadingScript />
        </RenderIf>
        <RenderIf condition={subjectScript !== ''}>
          <>
            <Typography component="p" className={classes.leftTitle}>
              Subject
            </Typography>
            <ReactTyped
            className={classes.typedSpan}
              strings={[subjectScript?.replace(/^\s+|\s+$/g, '') || '']}
              typeSpeed={20}
              onComplete={() => setSubjectCompleted(true)}
              cursorChar="▋"
            />
            <Grid container className={classes.actionButtonsContainer}>
              <Button
                variant="outlined"
                className={classes.actionButton}
                onClick={() => handleCopyToClipboardEmail(subjectScript || '')}
              >
                <SVGCopyClipboard color={theme.palette.primary.main} />
                <RenderIf condition={isMobile}>
                  <Typography component="span">
                    Copy
                  </Typography>
                </RenderIf>
              </Button>
            </Grid>
          </>
        </RenderIf>
        <RenderIf condition={contentScript !== '' && subjectCompleted}>
          <>
            <Typography component="p" className={classes.leftTitle}>
              Email
            </Typography>
            <ReactTyped
              className={classes.typedSpan}
              strings={[contentScript?.replace(/^[.:]\s+|\s+$/g, '') || '']}
              typeSpeed={20}
              cursorChar="▋"
            />
            <Grid container className={classes.actionButtonsContainer}>
              <Button
                variant="outlined"
                className={classes.actionButton}
                onClick={() => handleCopyToClipboardEmail(contentScript, 'content')}
              >
                <SVGCopyClipboard color={theme.palette.primary.main} />
                <RenderIf condition={isMobile}>
                  <Typography component="span">
                    Copy
                  </Typography>
                </RenderIf>
              </Button>
            </Grid>
          </>
        </RenderIf>
      </Grid>
    </Slide>
  )
}

export default EmailPanel
